"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
// Components
var UploadModal_1 = __importDefault(require("@src/components/BotModals/UploadModal"));
// Hooks
var useInterval_1 = __importDefault(require("@src/hooks/useInterval"));
// Actions
var BotActions_1 = require("@src/actions/BotActions");
// Constants
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
// Icon
var Download_svg_1 = __importDefault(require("../../icons/Download.svg"));
var Upload_svg_1 = __importDefault(require("../../icons/Upload.svg"));
var OrderedList = styled_components_1["default"]('ol')(function (props) { return ({
    paddingInlineStart: 20,
    color: props.theme.colors.black.haptik,
    'li:not(:first-of-type)': {
        marginTop: '24px',
    },
}); });
var StepsText = styled_components_1["default"](text_1["default"])(function (props) { return ({
    color: props.theme.colors.black.haptik,
}); });
var DownloadButton = styled_components_1["default"](button_1["default"])({
    width: 230,
    height: 42,
    margin: '16px 0px 0px 0px',
});
var ButtonText = styled_components_1["default"](text_1["default"])(function (props) { return ({
    marginLeft: '10px',
    color: props.theme.colors.grey.pastel,
    textAlign: 'left',
}); });
var IconWrapper = styled_components_1["default"](icon_1["default"])({
    width: 20,
});
var UploadButton = styled_components_1["default"](button_1["default"])(function (props) { return ({
    width: 161,
    height: 42,
    backgroundColor: props.theme.colors.green.haptik,
    margin: '16px 0px 0px 0px',
}); });
var LoadingStateWrapper = styled_components_1["default"](box_1["default"])(function (props) { return ({
    width: 493,
    height: 49,
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: props.theme.colors.green.deep,
    margin: '16px 4px',
    padding: '14px 9px',
    borderRadius: props.theme.radii.sm,
}); });
var LoadingText = styled_components_1["default"](text_1["default"])(function (props) { return ({
    paddingTop: 12,
    color: props.theme.colors.grey.pastel,
}); });
var LinkText = styled_components_1["default"]('a')(function (props) { return ({
    textDecoration: 'none',
    color: props.theme.colors.blue.haptik,
}); });
var HiddenFileInput = styled_components_1["default"]('input')({
    display: 'none',
});
/**
 * A modal which will be shown when the user taps on Bulk Upload FAQ Button. Users can use this modal to
 * download or upload the FAQ Nodes through TSV Sheet.
 */
var FAQUploadModal = function (_a) {
    var isActive = _a.isActive, isEmptyList = _a.isEmptyList, isDownloadStarted = _a.isDownloadStarted, onClose = _a.onClose, onDownload = _a.onDownload, onUpload = _a.onUpload, botId = _a.botId;
    var fileInput = react_1.useRef(null);
    var _b = react_1.useState(false), uploadInProgress = _b[0], setUploadInProgress = _b[1];
    var fetchUploadStatus = function () {
        BotActions_1.getBulkActionsStatus(botId).then(function (_a) {
            var _b, _c;
            var success = _a.success, response = _a.response;
            if (!success) {
                onClose();
                BotActions_1.createAlert('Error while fetching the upload status', undefined, MogamboConstants_1.AlertTypes.NEGATIVE);
                return;
            }
            // eslint-disable-next-line camelcase
            var status = (_c = (_b = response === null || response === void 0 ? void 0 : response.body) === null || _b === void 0 ? void 0 : _b.faq) === null || _c === void 0 ? void 0 : _c.in_progress;
            setUploadInProgress(status);
        });
    };
    useInterval_1["default"](function () {
        fetchUploadStatus();
    }, isActive ? 2000 : null);
    var handleFile = react_1.useCallback(function (event) {
        var _a, _b;
        var uploadedFile = (_a = event.target) === null || _a === void 0 ? void 0 : _a.files[0];
        if (!uploadedFile || !((_b = uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.name) === null || _b === void 0 ? void 0 : _b.includes('.tsv'))) {
            onClose();
            BotActions_1.createAlert("" + (!uploadedFile
                ? 'Please try again.'
                : 'The file format you have uploaded is not supported. Please upload a valid tsv file.'), undefined, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        var formData = new FormData();
        formData.append('data', uploadedFile);
        onUpload(formData);
    }, [onUpload, onClose]);
    var onUploadClick = react_1.useCallback(function () {
        // eslint-disable-next-line no-unused-expressions
        fileInput.current && fileInput.current.click();
    }, [fileInput]);
    var UploadStep = react_1.useCallback(function () {
        return (react_1["default"].createElement(OrderedList, { start: "3" },
            react_1["default"].createElement("li", null,
                react_1["default"].createElement(box_1["default"], { padding: "zero", flexDirection: "column" },
                    react_1["default"].createElement(StepsText, { variant: "body.lg" }, "Upload the TSV file here to update the FAQs in your bot."),
                    react_1["default"].createElement(UploadButton, { themed: true, onClick: onUploadClick },
                        react_1["default"].createElement(box_1["default"], { padding: "zero", alignItems: "center" },
                            react_1["default"].createElement(IconWrapper, { src: Upload_svg_1["default"] }),
                            react_1["default"].createElement(ButtonText, { variant: "h4.semi-bold" }, "Upload FAQ TSV")),
                        react_1["default"].createElement(HiddenFileInput, { ref: fileInput, onChange: handleFile, type: "file", accept: ".tsv" }))))));
    }, [handleFile, onUploadClick]);
    var UploadLoadingState = react_1.useCallback(function () {
        return (react_1["default"].createElement(LoadingStateWrapper, null,
            react_1["default"].createElement(loader_1["default"], { themed: true, color: "white", size: 16 }),
            react_1["default"].createElement(LoadingText, null, "Your file is being uploaded. This might take upto one minute.")));
    }, []);
    var DownloadStep = react_1.useCallback(function () {
        return (react_1["default"].createElement(OrderedList, null,
            react_1["default"].createElement("li", null,
                react_1["default"].createElement(box_1["default"], { padding: "zero", flexDirection: "column" },
                    react_1["default"].createElement(StepsText, { variant: "body.lg" },
                        "Download the ",
                        isEmptyList ? 'sample' : 'current',
                        " FAQ TSV file by clicking on the button below."),
                    react_1["default"].createElement(DownloadButton, { themed: true, onClick: onDownload, disabled: isDownloadStarted },
                        react_1["default"].createElement(box_1["default"], { padding: "zero", alignItems: "center", justifyContent: "center" },
                            isDownloadStarted ? (react_1["default"].createElement(loader_1["default"], { themed: true, color: "white", size: 16 })) : (react_1["default"].createElement(IconWrapper, { src: Download_svg_1["default"] })),
                            !isDownloadStarted && (react_1["default"].createElement(ButtonText, { variant: "h4.semi-bold" },
                                "Download ",
                                isEmptyList ? 'Sample' : 'Current',
                                " FAQ TSV")))))),
            react_1["default"].createElement("li", null,
                react_1["default"].createElement(StepsText, { variant: "body.lg" }, "Update this downloaded TSV file with the actual FAQs that you want to upload."))));
    }, [isEmptyList, isDownloadStarted, onDownload]);
    return (react_1["default"].createElement(UploadModal_1["default"], { isActive: isActive, onClose: onClose, modalStyles: { maxHeight: '90vh' }, headerText: "Upload all your FAQs in one click with a tsv file.", downloadContent: react_1["default"].createElement(DownloadStep, null), uploadContent: uploadInProgress ? react_1["default"].createElement(UploadLoadingState, null) : react_1["default"].createElement(UploadStep, null), footerText: react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(LinkText, { target: "_blank", href: "https://docs.haptik.ai/essentials/how-to-configure-faq-section?from_search=84225810" }, "Click here"),
            ' ',
            "to learn more about FAQs") }));
};
exports["default"] = FAQUploadModal;
